import React from 'react';
import { AppIcon } from '../../../components/icons/AppIcon';

export interface TrialBadgeProps {
    /** Dias restantes do trial */
    daysLeft: number;
    /** Total de dias do trial (para contexto) */
    totalDays?: number;
    /** Tamanho do badge */
    size?: 'sm' | 'md' | 'lg';
}

export const TrialBadge: React.FC<TrialBadgeProps> = ({
    daysLeft,
    totalDays = 7,
    size = 'md'
}) => {
    // Configuração de urgência baseada nos dias restantes
    const getUrgencyConfig = () => {
        if (daysLeft <= 0) {
            return {
                bgColor: 'bg-red-50',
                textColor: 'text-red-700',
                iconColor: 'text-red-500',
                label: 'Período de teste expirado'
            };
        }
        if (daysLeft <= 3) {
            return {
                bgColor: 'bg-amber-50',
                textColor: 'text-amber-700',
                iconColor: 'text-amber-500',
                label: daysLeft === 1
                    ? '1 dia de teste restante'
                    : `${daysLeft} dias de teste restantes`
            };
        }
        return {
            bgColor: 'bg-blue-50',
            textColor: 'text-blue-700',
            iconColor: 'text-blue-500',
            label: `${daysLeft} dias de teste grátis`
        };
    };

    const config = getUrgencyConfig();

    // Configuração de tamanho
    const sizeConfig = {
        sm: {
            padding: 'px-3 py-1.5',
            text: 'text-xs',
            icon: 'w-3.5 h-3.5',
            gap: 'gap-1.5'
        },
        md: {
            padding: 'px-4 py-2',
            text: 'text-sm',
            icon: 'w-4 h-4',
            gap: 'gap-2'
        },
        lg: {
            padding: 'px-5 py-2.5',
            text: 'text-base',
            icon: 'w-5 h-5',
            gap: 'gap-2.5'
        }
    };

    const sizeStyles = sizeConfig[size];

    return (
        <div
            className={`
                inline-flex items-center ${sizeStyles.gap} ${sizeStyles.padding} 
                ${config.bgColor} ${config.textColor} 
                rounded-full ${sizeStyles.text} font-semibold
                shadow-sm
            `}
        >
            <AppIcon name="clock" className={`${sizeStyles.icon} ${config.iconColor}`} />
            <span>{config.label}</span>
        </div>
    );
};

export default TrialBadge;
